<template>
    <Head>
        <title>Создание менеджера</title>
    </Head>

    <AuthenticatedLayout>
        <template #header>
            <NavigationSettings />
        </template>

        <form @submit.prevent="submit"
            class="py-8 max-w-2xl mx-auto grid gap-4">
            <div class="flex flex-col gap-4 p-6 bg-white border border-gray-200 sm:rounded-lg">

                <h3 class="font-semibold text-xl text-gray-800 sm:leading-tight">
                    Создание менеджера
                </h3>

                <v-input v-model="form.username" label="Имя пользователя (username)" :error="form.errors.username" required />

                <v-input v-model="form.name" label="Полное имя" :error="form.errors.name" required />

                <v-select v-model="form.role" label="Роль" :error="form.errors.role">
                    <option v-for="(r) in roles" :value="r">{{ r }}</option>
                </v-select>

                <v-select v-model="form.mentorId" label="Ментор" :error="form.errors.mentorId">
                    <option :value="null">Не задан</option>
                    <option v-for="(m, i) in mentors" :value="i">{{ m }}</option>
                </v-select>

                <div class="mt-4 flex flex-row justify-end gap-4">
                    <ButtonSecondary :href="route('settings.users.index')">
                        <span class="ml-2">
                            Назад к менеджерам
                        </span>
                    </ButtonSecondary>
                    <Button>
                        Создать
                    </Button>
                </div>

            </div>
        </form>
    </AuthenticatedLayout>
</template>

<script>
import { Head, useForm } from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import NavigationSettings from '@/Components/Navigation/Settings';
import Button from "@/Components/Button";
import ButtonSecondary from "@/Components/ButtonSecondary";
import VInput from "@/Components/Input";
import VSelect from "@/Components/Select";

export default {
    components: {
        Head,
        AuthenticatedLayout,
        NavigationSettings,
        Button,
        ButtonSecondary,
        VInput,
        VSelect,
    },
    props: {
        roles: Object,
        mentors: Object,
    },
    setup () {
        const form = useForm({
            username: '',
            name: '',
            mentorId: '',
            role: 'default',
        })
        return {form}
    },
    methods: {
        submit() {
            this.form.post(this.route('settings.users.store'))
        }
    }
}
</script>
